import * as React from "react"
import { RentalAdvertPricing } from '../../../../types/types'
import { FormattedNumber } from "react-intl";

type Props = {
  pricing: RentalAdvertPricing
}
export default (props: Props) => (
  props.pricing.price ?
    <>
      <span className="price__label">
        {props.pricing.priceLabel}
        {
          props.pricing.extraPricingDetails ?
            require('html-react-parser')(
              props.pricing.extraPricingDetails
            )
          : ''
        }
      </span>
      <span className="price__amount"><FormattedNumber
        value={props.pricing.price}
        style='currency'
        currency='EUR'
        minimumFractionDigits={props.pricing.price % 1 === 0 ? 0 : 2}
        maximumFractionDigits={props.pricing.price % 1 === 0 ? 0 : 2}
      /></span>
    </>
    :
    <span className="price_unknown">
      {props.pricing.priceLabel}
    </span>
)
